/* eslint-disable */
export default {
  confirmationInfo:
    'Irá perder as edições não guardadas na chamada anterior. Tem a certeza de que pretende trabalhar na nova chamada?',
  log: 'Registo',
  save: 'Guardar e trabalhar na nova',
  discard: 'Rejeitar e trabalhar na nova',
  stay: 'Permanecer no trabalho anterior',
} as const;

// @key: @#@"confirmationInfo"@#@ @source: @#@"Your unsaved edits on the previous call will be lost, are you sure you want to work on the new call?"@#@
// @key: @#@"log"@#@ @source: @#@"Log"@#@
// @key: @#@"save"@#@ @source: @#@"Save & Work on New"@#@
// @key: @#@"discard"@#@ @source: @#@"Discard & Work on New"@#@
// @key: @#@"stay"@#@ @source: @#@"Stay on Previous Work"@#@
